export default __webpack_public_path__ + "img/tremors/tremors5_1500.webp";